var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthcare0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 395,
    viewBox: "0 0 620 395",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.976 313.583C234.491 294.637 218.801 280.067 198.562 279.578C186.795 279.293 175.38 284.343 165.36 290.096C151.831 297.864 135.881 307.244 119.695 304.886C109.327 303.376 97.0425 297.558 94.6101 285.537C92.0349 272.815 102.315 264.09 113.302 258.973C122.715 254.589 135.923 244.104 140.153 234.067C156.928 194.262 110.02 148.834 123.259 103.47C137.113 55.9955 201.265 47.9701 233.513 80.2049C236.604 83.2951 239.496 86.5928 242.125 90.0857C248.706 98.8251 252.578 110.727 261.726 117.285C273.573 125.773 288.92 123.057 301.678 118.017C326.06 108.382 332.508 102.026 356.348 91.6499C373.495 84.1871 394.615 77.5288 413.881 84.1605C427.686 88.9129 442.933 97.4562 450.654 109.826C465.011 132.828 458.564 157.608 481.261 190.317C491.545 205.137 507.89 209.292 520.911 220.001C554.672 247.763 543.385 306.288 506.565 326.316C476.332 342.762 439.105 339.004 406.319 334.791C403.806 334.468 401.296 334.12 398.789 333.753",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeDasharray: "3.5 3.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M479.334 97.8325C482.171 94.5966 484.689 90.9923 486.787 87.0206C488.884 83.0479 490.441 78.9371 491.514 74.7683L480.26 70.7784C481.16 66.8905 481.508 62.9492 481.346 59.0536L493.159 57.2162C492.582 48.4292 489.941 39.8764 485.463 32.2928L474.671 37.4355C472.608 34.1273 470.099 31.0685 467.163 28.3648L474.209 18.7239C470.973 15.8859 467.369 13.3679 463.397 11.2697C459.425 9.17242 455.313 7.61494 451.146 6.54203L447.156 17.7966C443.268 16.896 439.326 16.5485 435.431 16.7104L433.594 4.89697C424.806 5.47484 416.254 8.11569 408.67 12.593L413.813 23.3858C410.505 25.4488 407.446 27.9583 404.742 30.8943L395.101 23.8485C392.263 27.0844 389.745 30.6886 387.648 34.6604C385.55 38.6322 383.993 42.7439 382.92 46.9127L394.175 50.9025C393.274 54.7905 392.927 58.7327 393.089 62.6274L381.275 64.4648C381.853 73.2517 384.494 81.8045 388.971 89.3882L399.764 84.2455C401.827 87.5537 404.336 90.6125 407.272 93.3162L400.226 102.957C403.462 105.795 407.066 108.313 411.038 110.41C415.009 112.509 419.121 114.065 423.289 115.138L427.279 103.883C431.167 104.784 435.109 105.131 439.004 104.97L440.841 116.783C449.628 116.205 458.181 113.564 465.765 109.087L460.622 98.2942C463.93 96.2312 466.989 93.7227 469.693 90.7867L479.334 97.8325ZM424.137 85.6059C410.46 78.3821 405.228 61.4383 412.451 47.76C419.675 34.0825 436.619 28.8503 450.297 36.0741C463.975 43.2979 469.207 60.2417 461.983 73.92C454.759 87.5975 437.815 92.8297 424.137 85.6059ZM427.922 78.4383C418.203 73.3051 414.486 61.2651 419.619 51.5461C424.752 41.8271 436.792 38.1095 446.511 43.2427C456.23 48.3759 459.948 60.4149 454.815 70.1339C449.681 79.8529 437.641 83.5705 427.922 78.4383Z",
    fill: "#E4E9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.622 124.925C225.171 122.757 226.5 120.381 227.547 117.804C228.594 115.227 229.3 112.599 229.704 109.965L222.524 108.201C222.839 105.749 222.811 103.3 222.471 100.91L229.636 99.05C228.738 93.6721 226.583 88.5646 223.357 84.1692L217.024 88.0029C215.55 86.0923 213.815 84.3625 211.839 82.8774L215.585 76.5028C213.416 74.9538 211.041 73.6249 208.464 72.5776C205.887 71.5304 203.258 70.8241 200.624 70.4204L198.86 77.6004C196.409 77.2853 193.959 77.3139 191.57 77.6537L189.709 70.489C184.332 71.3867 179.224 73.5411 174.829 76.7674L178.662 83.1001C176.752 84.5748 175.021 86.3093 173.537 88.2857L167.162 84.5396C165.613 86.7082 164.284 89.0835 163.237 91.6605C162.19 94.2376 161.483 96.8661 161.08 99.5003L168.26 101.264C167.945 103.716 167.973 106.165 168.313 108.555L161.148 110.415C162.046 115.793 164.2 120.9 167.427 125.296L173.76 121.462C175.234 123.373 176.969 125.103 178.944 126.588L175.198 132.962C177.367 134.511 179.743 135.84 182.319 136.887C184.895 137.935 187.525 138.641 190.159 139.045L191.923 131.865C194.374 132.18 196.824 132.151 199.213 131.811L201.074 138.976C206.451 138.078 211.559 135.924 215.954 132.698L212.121 126.366C214.031 124.891 215.762 123.157 217.246 121.18L223.622 124.925ZM188.861 120.796C179.989 117.188 175.721 107.072 179.328 98.1989C182.935 89.3262 193.052 85.0584 201.925 88.6655C210.797 92.2727 215.065 102.39 211.458 111.262C207.851 120.135 197.734 124.403 188.861 120.796ZM190.752 116.146C184.448 113.583 181.415 106.394 183.977 100.09C186.54 93.7854 193.73 90.7523 200.034 93.3161C206.338 95.8789 209.371 103.067 206.808 109.373C204.245 115.676 197.056 118.709 190.752 116.146Z",
    fill: "#E4E9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M252.124 58.8963C253.354 57.494 254.446 55.9308 255.355 54.2096C256.264 52.4874 256.939 50.7052 257.405 48.8983L252.526 47.1685C252.916 45.4835 253.066 43.7747 252.997 42.0858L258.118 41.289C257.867 37.48 256.722 33.7729 254.782 30.4856L250.104 32.7152C249.21 31.2815 248.122 29.9554 246.849 28.7835L249.903 24.6042C248.501 23.3742 246.938 22.2822 245.216 21.3731C243.494 20.4639 241.712 19.7889 239.905 19.3244L238.175 24.2024C236.49 23.8121 234.781 23.6617 233.092 23.7312L232.296 18.6104C228.487 18.8607 224.78 20.006 221.492 21.9462L223.722 26.6243C222.288 27.5182 220.962 28.6064 219.79 29.8792L215.611 26.8252C214.381 28.2275 213.289 29.7907 212.38 31.5119C211.47 33.2341 210.796 35.0162 210.33 36.8231L215.208 38.5529C214.818 40.238 214.667 41.9468 214.737 43.6357L209.616 44.4325C209.866 48.2414 211.011 51.9485 212.952 55.2358L217.63 53.0062C218.524 54.4399 219.612 55.7661 220.884 56.938L217.83 61.1173C219.232 62.3473 220.795 63.4392 222.517 64.3484C224.239 65.2575 226.021 65.9325 227.828 66.398L229.558 61.519C231.243 61.9094 232.952 62.0598 234.64 61.9903L235.437 67.1111C239.246 66.8607 242.953 65.7164 246.241 63.7753L244.011 59.0971C245.445 58.2032 246.771 57.1151 247.943 55.8422L252.124 58.8963ZM229.785 50.591C225.516 48.3366 223.884 43.0483 226.138 38.7795C228.392 34.5107 233.681 32.878 237.95 35.1324C242.218 37.3867 243.851 42.6751 241.597 46.9439C239.342 51.2126 234.054 52.8453 229.785 50.591Z",
    fill: "#E4E9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.09 134.824C137.058 134.189 137.005 133.514 136.925 132.793C136.272 126.882 132.222 127.424 129.702 127.604C127.182 127.784 124.049 127.879 122.844 125.129C122.32 123.933 122.342 122.488 121.998 121.195C121.234 118.329 118.685 116.612 116.25 116.606C113.814 116.6 111.51 117.997 109.514 119.727C108.477 120.625 107.309 121.678 106.075 121.339C105.283 121.122 104.666 120.363 104.173 119.566C101.287 114.88 101.305 108.066 98.1443 103.661C94.6552 98.7958 88.1387 98.6978 83.7271 102.229C79.3156 105.76 76.7823 112.052 75.6265 118.4C75.2505 120.464 74.9259 122.727 73.653 124.136C71.8328 126.149 69.0463 125.483 66.6177 125.21C63.7988 124.894 60.7915 125.354 58.5038 127.42C56.6379 129.104 55.4241 132.052 55.6554 134.825L137.09 134.824Z",
    fill: "white",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M300.157 32.4314H380.293C380.293 32.4314 377.08 28.6958 373.446 27.422C368.872 25.8188 366.969 30.3209 364.081 24.4994C362.462 21.233 361.326 16.9328 357.064 15.8161C350.398 14.0702 348.703 19.5785 345.527 18.0895C342.738 16.7824 342.825 11.5531 340.011 7.18147C337.26 2.90888 330.555 0.279451 325.982 2.50809C317.626 6.57981 318.712 13.0572 315.975 15.1926C313.274 17.3003 307.079 9.8804 300.157 17.9029C295.385 23.435 300.157 32.4314 300.157 32.4314Z",
    fill: "white",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M383.81 4.89778C383.81 6.84082 382.236 8.41543 380.293 8.41543C378.351 8.41543 376.775 6.84082 376.775 4.89778C376.775 2.95569 378.35 1.38013 380.293 1.38013C382.235 1.38013 383.81 2.95474 383.81 4.89778Z",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M615.557 288.301C615.557 290.243 613.982 291.819 612.039 291.819C610.096 291.819 608.521 290.244 608.521 288.301C608.521 286.358 610.096 284.784 612.039 284.784C613.981 284.784 615.557 286.358 615.557 288.301Z",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M447.605 142.592C447.605 144.534 446.031 146.109 444.088 146.109C442.146 146.109 440.57 144.535 440.57 142.592C440.57 140.649 442.145 139.074 444.088 139.074C446.031 139.074 447.605 140.65 447.605 142.592Z",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6754 184.292C12.6754 186.234 11.1008 187.81 9.15779 187.81C7.21475 187.81 5.64014 186.235 5.64014 184.292C5.64014 182.349 7.21475 180.775 9.15779 180.775C11.1008 180.775 12.6754 182.349 12.6754 184.292Z",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.132 52.4647C156.132 54.4077 154.557 55.9823 152.614 55.9823C150.671 55.9823 149.096 54.4077 149.096 52.4647C149.096 50.5216 150.671 48.947 152.614 48.947C154.556 48.947 156.132 50.5216 156.132 52.4647Z",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M197.783 36.4708C197.783 37.7912 196.712 38.8613 195.391 38.8613C194.071 38.8613 193 37.7912 193 36.4708C193 35.1504 194.07 34.0793 195.391 34.0793C196.713 34.0793 197.783 35.1504 197.783 36.4708Z",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M587.102 205.688C587.102 207.009 586.032 208.08 584.711 208.08C583.391 208.08 582.32 207.01 582.32 205.688C582.32 204.368 583.39 203.297 584.711 203.297C586.031 203.297 587.102 204.368 587.102 205.688Z",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M413.43 128.959C414.751 128.959 415.822 127.888 415.822 126.567C415.822 125.247 414.751 124.176 413.43 124.176C412.109 124.176 411.039 125.247 411.039 126.567C411.039 127.888 412.109 128.959 413.43 128.959Z",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M509.844 66.4212C509.844 67.7416 508.773 68.8126 507.453 68.8126C506.132 68.8126 505.061 67.7426 505.061 66.4212C505.061 65.0998 506.131 64.0298 507.453 64.0298C508.773 64.0307 509.844 65.1008 509.844 66.4212Z",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M504.755 241.537C504.755 242.857 503.684 243.928 502.364 243.928C501.043 243.928 499.972 242.858 499.972 241.537C499.972 240.217 501.042 239.146 502.364 239.146C503.684 239.146 504.755 240.217 504.755 241.537Z",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M133.747 264.423C133.747 265.744 132.676 266.815 131.356 266.815C130.035 266.815 128.964 265.745 128.964 264.423C128.964 263.103 130.034 262.032 131.356 262.032C132.677 262.032 133.747 263.103 133.747 264.423Z",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M140.919 155.217C140.919 156.538 139.849 157.609 138.528 157.609C137.207 157.609 136.136 156.539 136.136 155.217C136.136 153.897 137.207 152.826 138.528 152.826C139.849 152.826 140.919 153.897 140.919 155.217Z",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M601.805 171.493H598.603C598.028 171.493 597.561 171.027 597.561 170.452V167.249C597.561 166.674 598.028 166.207 598.603 166.207H601.805C602.38 166.207 602.847 166.674 602.847 167.249V170.452C602.847 171.028 602.38 171.493 601.805 171.493Z",
    fill: "#E4E9F9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 281.53H106.297C105.722 281.53 105.255 281.063 105.255 280.488V277.285C105.255 276.71 105.722 276.243 106.297 276.243H109.5C110.075 276.243 110.542 276.71 110.542 277.285V280.488C110.542 281.064 110.076 281.53 109.5 281.53Z",
    fill: "#E4E9F9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M103.935 86.8036H100.732C100.157 86.8036 99.6905 86.3371 99.6905 85.7621V82.5586C99.6905 81.9836 100.157 81.5171 100.732 81.5171H103.935C104.51 81.5171 104.977 81.9836 104.977 82.5586V85.7621C104.977 86.338 104.51 86.8036 103.935 86.8036Z",
    fill: "#E4E9F9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M514.884 49.0049H508.738C507.635 49.0049 506.74 48.1101 506.74 47.0067V40.8606C506.74 39.7572 507.635 38.8623 508.738 38.8623H514.884C515.988 38.8623 516.883 39.7572 516.883 40.8606V47.0067C516.883 48.1101 515.988 49.0049 514.884 49.0049Z",
    fill: "#E4E9F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M457.522 202.249H454.319C453.744 202.249 453.277 201.783 453.277 201.208V198.004C453.277 197.429 453.744 196.963 454.319 196.963H457.522C458.097 196.963 458.564 197.429 458.564 198.004V201.208C458.564 201.783 458.097 202.249 457.522 202.249Z",
    fill: "#E4E9F9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M384.668 164.324C384.693 163.869 384.737 163.383 384.803 162.866C385.339 158.625 388.663 159.015 390.732 159.143C392.801 159.272 395.373 159.34 396.362 157.368C396.792 156.509 396.773 155.473 397.056 154.545C397.684 152.488 399.776 151.256 401.775 151.251C403.773 151.247 405.661 152.247 407.299 153.486C412.613 157.511 414.137 146.914 416.653 143.847C419.517 140.357 424.85 138.401 428.471 140.934C432.093 143.467 434.172 147.983 435.12 152.538C435.429 154.018 435.539 155.835 436.74 156.654C440.254 159.049 444.777 154.402 449.023 158.01C450.509 159.273 450.791 162.333 450.602 164.323H384.668V164.324Z",
    fill: "white",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M122.427 381.948C110.492 363.943 85.5026 318.451 107.162 302.795C119.055 294.197 134.821 302.02 142.444 320.98C149.683 338.985 152.452 360.255 155.469 381.694",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M122.682 381.8C116.969 373.05 111.83 363.876 107.568 354.332C102.953 343.992 98.7034 332.478 99.0137 320.985C99.2917 310.692 105.548 300.157 116.873 299.711C131.18 299.149 139.693 314.072 143.775 325.655C150.136 343.706 152.432 362.943 155.084 381.801C155.155 382.31 155.929 382.094 155.859 381.587C153.282 363.256 151.027 344.61 145.09 326.991C141.147 315.291 133.904 301.181 120.257 299.143C110.149 297.634 101.338 305.066 99.0661 314.614C96.4519 325.603 100.123 337.653 104.082 347.855C108.749 359.88 115.005 371.385 122.175 382.096C122.384 382.408 122.89 382.119 122.682 381.8Z",
    fill: "#ADBBF9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M113.302 300.095L141.438 382.003",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5745 381.962C64.2776 368.643 41.7684 334.993 60.4534 323.412C70.7131 317.053 83.3624 322.839 89.9389 336.864C96.184 350.182 98.5726 365.915 101.175 381.774",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8273 381.814C70.0549 375.529 65.6042 368.967 61.8153 362.038C57.7816 354.662 53.8317 346.289 53.649 337.72C53.4671 329.208 59.1239 322.004 67.9176 321.274C78.9504 320.358 86.6978 330.227 90.5944 339.309C96.3702 352.772 98.4341 367.53 100.787 381.88C100.871 382.389 101.645 382.173 101.562 381.666C99.2471 367.537 97.1956 353.06 91.6539 339.753C87.9297 330.811 81.1571 321.399 70.6489 320.516C62.8158 319.858 55.0846 324.975 53.3605 332.747C51.5422 340.942 54.9913 349.794 58.4604 357.078C62.7178 366.016 68.2708 374.384 74.3655 382.169C74.5693 382.43 75.0291 382.08 74.8273 381.814Z",
    fill: "#ADBBF9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7491 321.415L90.0214 382.003",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M194.981 381.774C166.768 330.596 148.547 279.857 171.311 255.753C193.869 231.87 217.463 260.172 223.204 285.251C230.234 315.967 231.254 349.215 231.115 381.774",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M194.981 381.774C166.768 330.596 148.547 279.857 171.311 255.753C193.869 231.87 217.463 260.172 223.204 285.251C230.234 315.967 231.254 349.215 231.115 381.774",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M179.664 249.535L213.554 381.699",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M152.646 381.934C141.438 354.86 116.229 300.095 134.008 283.167C145.377 272.342 165.907 285.612 176.472 309.27C186.504 331.736 189.517 354.865 195.531 381.616",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M152.928 381.856C147.608 368.846 141.997 355.961 137.321 342.696C132.628 329.383 127.935 314.974 128.222 300.692C128.328 295.446 129.245 289.86 132.422 285.534C136.074 280.561 141.956 278.788 147.853 280.293C154.776 282.06 160.649 287.021 165.268 292.28C171.559 299.443 175.782 307.958 179.147 316.812C187.086 337.702 190.281 360.011 195.144 381.724C195.257 382.228 196.031 382.015 195.919 381.51C191.287 360.823 188.175 339.624 181.031 319.59C175.681 304.59 167.126 287.434 151.592 280.772C146.594 278.629 140.74 278.087 135.984 281.139C131.707 283.883 129.305 288.597 128.266 293.446C126.972 299.477 127.406 305.803 128.3 311.857C129.427 319.488 131.44 326.979 133.758 334.325C138.899 350.62 145.757 366.279 152.365 382.013C152.506 382.355 153.072 382.207 152.928 381.856Z",
    fill: "#ADBBF9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M371.305 381.782C361.797 272.83 384.941 233.025 410.259 231.239C422.253 230.393 457.385 237.299 414.967 381.716",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M371.492 381.782C369.15 345.907 366.752 308.63 376 273.443C380.01 258.19 387.527 238.514 403.965 232.884C410.449 230.664 417.817 231.073 423.309 235.458C433.016 243.206 434.523 258.285 434.89 269.716C435.303 282.541 433.908 295.411 431.932 308.063C428.957 327.113 424.482 345.918 419.429 364.513C417.875 370.229 416.262 375.928 414.69 381.64C414.592 381.997 415.132 382.143 415.242 381.792C421.68 361.121 426.95 339.943 430.883 318.65C433.47 304.65 435.473 290.429 435.681 276.172C435.807 267.499 435.332 258.591 432.912 250.214C431.487 245.279 429.297 240.37 425.682 236.639C421.025 231.834 414.522 230.104 408.016 231.135C392.121 233.655 383.128 249.892 378.257 263.654C373.681 276.58 371.46 290.294 370.173 303.904C368.288 323.838 368.525 343.954 369.706 363.922C370.058 369.883 370.478 375.843 371.118 381.78C371.144 382.015 371.507 382.024 371.492 381.782Z",
    fill: "#ADBBF9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M415.195 231.49L392.824 381.716",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M446.148 381.791C453.904 317.033 480.029 279.712 503.631 289.842C522.938 298.129 512.976 334.178 482.901 381.752",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M446.326 381.841C449.251 362.76 452.653 343.871 460.021 325.916C464.902 314.019 471.563 301.191 482.231 293.462C489.455 288.229 499.698 286.325 507.138 292.352C515.817 299.382 513.45 313.256 511.015 322.598C505.479 343.842 493.787 362.935 482.653 381.606C482.463 381.926 482.945 382.2 483.147 381.896C489.615 372.186 495.374 361.916 500.526 351.452C504.542 343.294 508.187 334.887 510.791 326.164C513.684 316.478 516.884 302.598 509.723 293.897C503.986 286.927 493.605 286.49 486.001 290.313C475.114 295.787 467.924 307.452 462.791 318.035C458.443 327 455.181 336.478 452.591 346.089C449.455 357.732 447.036 369.772 445.962 381.79C445.943 381.998 446.294 382.048 446.326 381.841Z",
    fill: "#ADBBF9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M503.632 289.841L465.012 381.751",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.153 279.799L174.652 382.004",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M449.027 381.909C464.282 349.572 495.044 275.735 471.876 249.554C459.154 235.178 435.871 252.83 423.522 284.534C411.795 314.64 403.016 345.635 395.739 381.485",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M449.282 382.058C457.272 365.258 464.452 348.008 470.248 330.324C476.218 312.104 481.673 292.338 480.459 272.978C479.713 261.106 474.077 241.856 458.551 244.326C450.145 245.664 443.097 252.271 437.887 258.565C430.236 267.809 425.29 278.606 421.093 289.75C409.888 319.5 401.688 350.249 395.351 381.379C395.249 381.883 396.023 382.099 396.126 381.592C401.541 354.996 408.282 328.659 417.165 302.998C421.302 291.045 425.446 278.859 432.111 268.037C437.142 259.868 443.76 251.548 452.51 247.151C459.298 243.74 466.738 244.154 471.885 250.133C476.716 255.745 478.775 263.237 479.511 270.466C481.385 288.844 476.494 307.847 471.102 325.261C465.11 344.619 457.341 363.411 448.774 381.762C448.615 382.101 449.119 382.401 449.282 382.058Z",
    fill: "#ADBBF9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M465.011 245.042L424.22 382.003",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M475.961 381.79C496.071 341.024 513.523 330.242 529.918 333.5C542.663 336.033 544.658 354.862 517.717 381.765",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M476.12 381.883C482.347 370.79 487.975 359.52 496.255 349.745C501.369 343.708 507.491 337.967 514.999 335.107C520.232 333.112 527.133 332.308 532.411 334.656C538.291 337.273 539.273 343.974 538.109 349.674C535.529 362.314 525.91 372.406 517.513 381.562C517.263 381.835 517.647 382.218 517.917 381.967C526.476 374.038 535.009 363.528 538.278 352.106C539.874 346.531 540.098 339.436 535.123 335.451C530.791 331.981 523.856 332.09 518.716 333.235C511.239 334.901 504.849 339.667 499.581 345.047C495.338 349.38 491.664 354.263 488.316 359.308C483.627 366.374 479.172 373.907 475.799 381.696C475.707 381.909 476 382.097 476.12 381.883Z",
    fill: "#ADBBF9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M528.338 333.772L497.614 381.762",
    stroke: "#ADBBF9",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M225.76 381.576C220.862 381.576 216.878 377.591 216.878 372.693V58.0853C216.878 53.1872 220.862 49.2021 225.76 49.2021H392.841C397.739 49.2021 401.724 53.1872 401.724 58.0853V372.692C401.724 377.591 397.739 381.575 392.841 381.575H225.76V381.576Z",
    fill: "#849CF4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M392.84 49.6781C397.476 49.6781 401.247 53.4499 401.247 58.0852V372.692C401.247 377.327 397.476 381.099 392.84 381.099H225.76C221.124 381.099 217.353 377.328 217.353 372.692V58.0852C217.353 53.4499 221.123 49.6781 225.76 49.6781H392.84ZM392.84 48.7261H225.76C220.591 48.7261 216.401 52.9158 216.401 58.0852V372.692C216.401 377.86 220.59 382.051 225.76 382.051H392.84C398.009 382.051 402.199 377.861 402.199 372.692V58.0852C402.199 52.9168 398.009 48.7261 392.84 48.7261Z",
    fill: "#849CF4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M317.787 366.762C317.787 371.45 313.986 375.251 309.299 375.251C304.611 375.251 300.811 371.45 300.811 366.762C300.811 362.075 304.611 358.274 309.299 358.274C313.986 358.274 317.787 362.075 317.787 366.762Z",
    stroke: "#4643BF",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_379_3931",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 216,
    y: 48,
    width: 187,
    height: 335
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M392.841 382.051H225.76C220.592 382.051 216.401 377.861 216.401 372.692V58.0852C216.401 52.9168 220.591 48.7261 225.76 48.7261H392.841C398.01 48.7261 402.2 52.9158 402.2 58.0852V372.692C402.2 377.861 398.009 382.051 392.841 382.051Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_379_3931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.311 12.6118L214.272 390.457H254.686L393.724 12.6118H353.311Z",
    fill: "url(#paint0_linear_379_3931)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.222 12.6118L267.182 390.457H284.318L423.356 12.6118H406.222Z",
    fill: "url(#paint1_linear_379_3931)"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M400.717 79.771H217.881V351.007H400.717V79.771Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M298.847 62.5559H324.596C325.166 62.5559 325.627 63.0176 325.627 63.5869C325.627 64.1562 325.166 64.6179 324.596 64.6179H298.847C298.278 64.6179 297.816 64.1562 297.816 63.5869C297.816 63.0176 298.278 62.5559 298.847 62.5559Z",
    stroke: "#4643BF",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M293.083 64.6502C293.67 64.6502 294.146 64.1741 294.146 63.5868C294.146 62.9995 293.67 62.5234 293.083 62.5234C292.496 62.5234 292.02 62.9995 292.02 63.5868C292.02 64.1741 292.496 64.6502 293.083 64.6502Z",
    stroke: "#4643BF",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M309.299 184.808H230.374V264.564H309.299V184.808Z",
    fill: "#D3DBF4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M285.95 215.828C287.388 206.919 281.331 198.531 272.422 197.094C263.513 195.656 255.126 201.713 253.688 210.622C252.251 219.531 258.307 227.918 267.216 229.356C276.125 230.794 284.513 224.737 285.95 215.828Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M269.836 229.565C276.053 229.565 281.092 222.249 281.092 213.224C281.092 204.2 276.053 196.884 269.836 196.884C263.619 196.884 258.579 204.2 258.579 213.224C258.579 222.249 263.619 229.565 269.836 229.565Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M269.835 229.565C272.257 229.565 274.22 222.249 274.22 213.224C274.22 204.2 272.257 196.884 269.835 196.884C267.414 196.884 265.451 204.2 265.451 213.224C265.451 222.249 267.414 229.565 269.835 229.565Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M253.496 213.225H286.176",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M255.207 220.51C258.33 219.466 263.715 218.777 269.836 218.777C275.954 218.777 281.339 219.465 284.461 220.509",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M259.947 226.233C262.759 225.165 266.164 224.539 269.835 224.539C273.456 224.539 276.819 225.147 279.608 226.19",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M255.207 206.03C258.33 207.073 263.715 207.762 269.836 207.762C275.954 207.762 281.339 207.074 284.461 206.03",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M259.947 200.306C262.759 201.375 266.164 202 269.835 202C273.456 202 276.819 201.391 279.608 200.349",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M237.087 250.306H302.585V246.088H237.087V250.306Z",
    fill: "#E3EAFC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M263.443 242.462H302.586V238.244H263.443V242.462Z",
    fill: "#E3EAFC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M258.994 238.244H237.087V242.463H258.994V238.244Z",
    fill: "#E3EAFC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M237.087 258.149H302.585V253.931H237.087V258.149Z",
    fill: "#E3EAFC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M388.142 184.808H309.217V264.564H388.142V184.808Z",
    fill: "#F0F1FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M315.93 203.243H381.428V199.025H315.93V203.243Z",
    fill: "#E4E9F9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M315.93 211.087H381.428V206.869H315.93V211.087Z",
    fill: "#E4E9F9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M315.93 218.93H336.325V214.712H315.93V218.93Z",
    fill: "#E4E9F9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M341.781 218.93H381.339V214.712H341.781V218.93Z",
    fill: "#E4E9F9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M315.93 226.774H381.428V222.556H315.93V226.774Z",
    fill: "#E4E9F9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M315.93 234.619H381.428V230.401H315.93V234.619Z",
    fill: "#E4E9F9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M315.93 242.462H381.428V238.244H315.93V242.462Z",
    fill: "#E4E9F9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M362.514 250.306H381.428V246.088H362.514V250.306Z",
    fill: "#E4E9F9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M315.93 250.306H357.999V246.088H315.93V250.306Z",
    fill: "#E4E9F9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M315.93 258.15H381.428V253.931H315.93V258.15Z",
    fill: "#E4E9F9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M364.08 195.399H381.428V191.18H364.08V195.399Z",
    fill: "#E4E9F9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M359.633 191.181H315.93V195.399H359.633V191.181Z",
    fill: "#E4E9F9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M309.299 264.564H230.374V344.32H309.299V264.564Z",
    fill: "#F0F1FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M302.586 325.865H237.088V330.083H302.586V325.865Z",
    fill: "#E4E9F9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M302.586 318.02H237.088V322.239H302.586V318.02Z",
    fill: "#E4E9F9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M302.585 310.177H285.741V314.395H302.585V310.177Z",
    fill: "#E4E9F9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M280.287 310.177H237.178V314.395H280.287V310.177Z",
    fill: "#E4E9F9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M302.586 302.333H237.088V306.551H302.586V302.333Z",
    fill: "#E4E9F9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M302.586 294.489H237.088V298.707H302.586V294.489Z",
    fill: "#E4E9F9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M302.586 286.645H237.088V290.863H302.586V286.645Z",
    fill: "#E4E9F9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M267.522 278.801H237.088V283.019H267.522V278.801Z",
    fill: "#E4E9F9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M302.586 278.801H272.037V283.019H302.586V278.801Z",
    fill: "#E4E9F9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M302.586 270.957H237.088V275.175H302.586V270.957Z",
    fill: "#E4E9F9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M267.613 333.708H237.088V337.927H267.613V333.708Z",
    fill: "#E4E9F9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M272.061 337.926H302.586V333.708H272.061V337.926Z",
    fill: "#E4E9F9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M388.142 264.564H309.217V344.32H388.142V264.564Z",
    fill: "#D3DBF4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M364.732 319.455L333.071 319.08L329.527 296.328L367.788 296.26L364.732 319.455Z",
    fill: "#C2CFEF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M367.788 296.26L329.527 296.328L348.63 280.566L367.788 296.26Z",
    fill: "#C2CFEF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M361.445 294.009L335.332 294.056L335.372 316.113L361.484 316.066L361.445 294.009Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M329.527 296.328L329.57 321.204L348.68 309.61L329.527 296.328Z",
    fill: "#E3EAFC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M367.789 296.26L367.833 321.136L348.681 309.61L367.789 296.26Z",
    fill: "#E3EAFC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M367.832 321.136L329.57 321.204L348.673 305.441L367.832 321.136Z",
    fill: "#E3EAFC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M329.57 321.204L348.673 305.441L367.832 321.136",
    stroke: "#D3DBF4",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M351.424 307.694L367.788 296.26",
    stroke: "#D3DBF4",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M345.933 307.706L329.527 296.328",
    stroke: "#D3DBF4",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M333.417 334.927H363.943V330.709H333.417V334.927Z",
    fill: "#E3EAFC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M388.225 98.1587H230.374V177.735H388.225V98.1587Z",
    fill: "#D3DBF4"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M307.076 115.107L381.43 115.107V109.601L307.076 109.601V115.107Z",
    fill: "#E3EAFC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M307.076 125.344L381.43 125.344V119.839L307.076 119.839V125.344Z",
    fill: "#E3EAFC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M307.076 135.581H381.43V130.075H307.076V135.581Z",
    fill: "#E3EAFC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M307.076 145.818H381.43V140.312H307.076V145.818Z",
    fill: "#E3EAFC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M307.076 166.293H381.43V160.788H307.076V166.293Z",
    fill: "#E3EAFC"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M336.994 156.055H381.429V150.55H336.994V156.055Z",
    fill: "#E3EAFC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M331.946 150.55H307.076V156.056H331.946V150.55Z",
    fill: "#E3EAFC"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M295.665 109.827H239.423V166.068H295.665V109.827Z",
    fill: "#E3EAFC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M272.759 127.408L289.874 156.68H255.644L272.759 127.408Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M255.416 137.027L259.07 144.067L252.523 156.68H245.214L255.416 137.027Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M246.653 125.716C246.653 127.467 248.073 128.886 249.824 128.886C251.574 128.886 252.994 127.467 252.994 125.716C252.994 123.965 251.574 122.546 249.824 122.546C248.072 122.546 246.653 123.965 246.653 125.716Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M264.782 91.6501H353.817C355.215 91.6501 356.349 90.5163 356.349 89.1178C356.349 87.7193 355.215 86.5854 353.817 86.5854H264.782C263.384 86.5854 262.25 87.7193 262.25 89.1178C262.25 90.5163 263.384 91.6501 264.782 91.6501Z",
    fill: "#D3DBF4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M309.299 184.808V344.319",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M230.374 264.564H388.224",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9043 382.051H574.693",
    stroke: "#849CF4",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M545.443 355.553L547.097 382.725L546.213 391.272L513.818 391.1C513.001 391.096 512.341 390.429 512.345 389.611C512.348 388.998 512.728 388.451 513.301 388.234L527.752 381.589L524.489 353.316",
    fill: "#FFCBBD"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M510.879 390.739C511.222 389.666 511.85 388.46 512.484 388.188L527.807 381.589C536.252 385.012 547.185 382.396 547.185 382.396L548.023 393.932C548.021 394.314 547.709 394.622 547.328 394.62L511.135 394.429C510.385 394.424 510.868 390.773 510.879 390.739Z",
    fill: "#FFC90D"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M524.49 382.25C525.349 383.368 526.075 384.589 526.65 385.877",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M522.561 383.402C523.45 384.634 523.805 385.344 524.336 386.487",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M520.93 384.244C521.534 385.056 522.127 386.178 522.595 387.074",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M547.827 392.129L510.723 391.933",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M547.492 386.608C547.492 386.608 538.9 386.668 538.128 392.078",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M515.624 386.835C515.624 386.835 518.099 390.353 518.588 391.975",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M519.993 251.134C519.993 251.134 515.337 289.374 517.118 317.144C518.899 344.913 521.469 377.135 521.469 377.135H549.628C549.628 377.135 545.978 329.454 546.38 307.13C546.826 282.399 554.386 251.135 554.386 251.135",
    fill: "#4A5FF7"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M543.915 377.135C543.915 377.135 540.265 329.454 540.668 307.13C541.113 282.399 548.673 251.135 548.673 251.135",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M582.443 319.163L608.559 327.563L616.438 330.99L606.476 361.816C606.225 362.595 605.39 363.021 604.611 362.77C604.028 362.582 603.621 362.053 603.587 361.442L601.624 345.658L574.507 336.847",
    fill: "#FFCBBD"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M605.244 364.508C604.324 363.857 603.366 362.894 603.297 362.208L601.642 345.606C607.459 338.592 608.272 327.38 608.272 327.38L619.521 330.071C619.884 330.188 620.084 330.578 619.967 330.941L608.838 365.38C608.608 366.094 605.273 364.529 605.244 364.508Z",
    fill: "#FFC90D"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M601.268 348.967C602.594 348.487 603.977 348.164 605.378 348.005",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M601.784 351.155C603.228 350.68 604.012 350.556 605.261 350.395",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M602.094 352.964C603.05 352.633 604.3 352.409 605.295 352.232",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M617.743 329.713L606.333 365.02",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M612.381 328.362C612.381 328.362 609.839 336.57 614.762 338.942",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M602.957 358.804C602.957 358.804 607.059 357.509 608.752 357.534",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M565.839 252.367C565.839 252.367 568.367 263.237 568.367 267.902C568.367 271.328 567.003 273.658 566.278 276.17C565.969 277.243 565.791 278.337 565.742 279.453C565.525 284.453 565.234 298.487 568.367 305.155C572.218 313.35 604.243 324.229 604.243 324.229L596.122 348.685C596.122 348.685 547.097 336.366 540.984 321.361C532.453 300.424 534.894 252.368 534.894 252.368",
    fill: "#3C52EF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M546.897 328.364C544.068 326.126 541.969 323.777 540.984 321.36C532.453 300.423 534.894 252.367 534.894 252.367",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M561.681 251.458C561.681 251.458 564.559 265.141 564.559 269.806C564.559 273.295 563.144 275.753 562.431 278.21C562.142 279.203 561.971 280.221 561.907 281.254C561.601 286.19 561.063 300.507 564.559 307.059C569.406 316.143 602.957 328.101 602.957 328.101",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M530.89 255.042C530.89 255.042 530.461 264.912 531.842 266.096C533.223 267.28 534.57 268.071 534.57 268.071",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M600.204 322.781L591.267 347.366",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M521.088 372.293H549.272",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M553.959 253.123C553.959 253.123 555.715 259.423 563.536 261.279",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M519.088 260.179C519.088 260.179 526.154 258.114 528.325 253.123",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M536.127 176.858L534.863 185.72C534.863 185.72 534.752 188.175 539.525 189.884C545.309 191.954 548.82 187.503 548.82 187.503L548.435 178.54",
    fill: "#FFCBBB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M535.42 165.112C535.42 165.112 529.281 175.376 533.545 179.478C537.412 183.199 545.915 180.867 546.689 179.568C547.463 178.268 552.303 166.798 549.654 165.22C544.947 162.415 538.049 160.699 535.42 165.112Z",
    fill: "#FFCBBB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M535.48 181.394C535.48 181.394 539.641 182.729 543.486 181.05",
    stroke: "#EF977F",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M534.393 158.443C535.2 152.38 542.547 156.916 545.538 159.685C546.435 160.516 551.678 162.056 552.531 162.934C553.384 163.811 554.073 164.889 554.298 166.091C554.494 167.145 554.326 168.234 554.07 169.275C553.61 171.146 552.872 172.937 552.137 174.719C551.336 176.662 549.903 180.527 547.132 180.123C546.596 180.045 546.011 179.94 545.659 179.529C545.311 179.122 545.294 178.531 545.354 177.999C545.452 177.131 545.717 176.286 546.116 175.51C545.541 175.664 544.951 176.01 544.401 175.792C544.219 175.72 544.13 175.543 544.028 175.376C543.663 174.784 544.105 170.865 545.93 169.321C543.294 168.073 541.231 167.959 538.542 166.828C536.379 165.918 535.447 164.811 534.673 163.773C533.567 162.288 534.15 160.278 534.393 158.443Z",
    fill: "#4A1A1A"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M545.468 175.155C546.139 174.212 547.177 173.132 548.164 174.115C548.513 174.463 548.613 175.052 548.649 175.608C548.768 177.457 546.901 179.818 545.268 179.169C544.472 178.853 544.248 177.766 544.104 176.88",
    fill: "#FFCBBB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M515.538 138.071C515.145 132.921 515.84 118.347 514.937 117.963C514.033 117.579 513.662 122.516 512.98 122.062C512.297 121.609 512.353 113.974 511.349 113.831C509.987 113.638 510.347 121.46 510.347 121.46C510.347 121.46 509.525 112.912 508.296 113.086C507.425 113.21 507.752 119.763 507.564 122.283C507.421 119.526 506.613 114.395 505.711 114.542C504.817 114.689 504.992 119.845 504.908 123.272C504.76 121.128 504.33 116.445 503.491 116.542C502.654 116.638 502.4 128.813 502.384 139.074",
    fill: "#FFCBBD"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M514.241 189.626C514.241 189.626 508.714 178.054 505.256 164.556C501.797 151.059 502.404 133.512 502.404 133.512L515.39 135.697C515.39 135.697 515.981 160.189 530.765 184.51",
    fill: "#FFCBBD"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M505.087 123.854C506.154 125.479 507.573 127.392 507.504 130.575",
    stroke: "#F7A794",
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M512.869 123.235C511.619 124.348 510.267 127.348 510.92 128.889",
    stroke: "#F7A794",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M557.329 135.585C559.227 133.356 560.905 130.881 562.294 128.159C563.682 125.438 564.701 122.625 565.39 119.781L557.697 117.176C558.272 114.523 558.47 111.838 558.323 109.191L566.34 107.826C565.862 101.855 563.982 96.0644 560.864 90.9503L553.573 94.5526C552.139 92.323 550.402 90.2667 548.379 88.456L553.077 81.831C550.849 79.9327 548.373 78.2543 545.652 76.8663C542.93 75.4783 540.118 74.4587 537.273 73.7695L534.668 81.4626C532.015 80.8876 529.331 80.6896 526.683 80.8371L525.319 72.8203C519.348 73.2982 513.557 75.1775 508.442 78.2962L512.045 85.5867C509.815 87.0213 507.759 88.7578 505.948 90.7808L499.322 86.0827C497.424 88.3113 495.746 90.7865 494.358 93.5092C492.97 96.231 491.95 99.0432 491.261 101.888L498.954 104.492C498.38 107.146 498.181 109.83 498.328 112.478L490.312 113.842C490.789 119.813 492.669 125.604 495.787 130.718L503.078 127.116C504.514 129.345 506.249 131.403 508.272 133.213L503.574 139.838C505.803 141.737 508.278 143.415 511 144.803C513.721 146.191 516.534 147.211 519.378 147.9L521.983 140.207C524.636 140.782 527.321 140.98 529.968 140.832L531.332 148.849C537.303 148.371 543.095 146.492 548.209 143.373L544.606 136.083C546.836 134.648 548.893 132.912 550.703 130.889L557.329 135.585ZM521.678 123.866C514.481 120.195 511.622 111.385 515.293 104.187C518.964 96.9898 527.775 94.1309 534.972 97.8018C542.169 101.473 545.028 110.284 541.357 117.481C537.686 124.678 528.875 127.537 521.678 123.866Z",
    fill: "#ADBBF9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M535.042 184.465C531.177 184.465 525.151 172.109 525.151 172.109L509.636 183.646C509.636 183.646 514.597 199.074 523.007 208.858",
    fill: "#FFC90D"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M526.447 174.576L510.634 186.451",
    stroke: "#F1BF0E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M575.178 131.765C574.349 126.1 572.194 112.755 571.237 112.535C570.28 112.316 569.89 115.497 570.276 116.792C569.67 114.367 567.994 109.06 566.98 109.095C565.606 109.144 567.331 116.782 567.331 116.782C567.331 116.782 565.024 108.51 563.844 108.896C563.008 109.171 564.478 115.564 564.733 118.078C564.11 115.389 562.416 110.48 561.553 110.781C560.698 111.082 561.774 116.128 562.291 119.517C561.77 117.432 560.527 112.897 559.718 113.14C558.91 113.38 561.014 123.851 562.265 134.294",
    fill: "#FFCBBD"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M572.499 185.03C572.499 185.03 575.935 172.675 577.001 158.782C578.067 144.889 574.427 127.714 574.427 127.714L562.017 132.117C562.017 132.117 565.681 156.34 555.338 182.857",
    fill: "#FFCBBD"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M535.042 184.465C535.042 184.465 535.795 186.639 540.076 186.858C545.588 187.14 548.654 184.465 548.654 184.465C548.654 184.465 565.088 186.646 566.416 204.6C567.945 225.278 568.367 254.323 568.367 254.323H517.117C517.117 254.323 517.461 221.154 518.54 205.328C519.575 190.162 535.042 184.465 535.042 184.465Z",
    fill: "#FFC90D"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M566.381 206.866C572.557 190.801 574.756 178.536 574.756 178.536L558.301 170.572C558.301 170.572 554.384 181.492 548.654 184.466",
    fill: "#FFC90D"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M556.976 173.726L574.052 181.897",
    stroke: "#F1BF0E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M517.117 251.487H568.318",
    stroke: "#F1BF0E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M566.829 205.688C566.829 205.688 564.746 210.152 564.522 212.396",
    stroke: "#F1BF0E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M522.34 193.885C522.34 193.885 519.231 199.158 518.541 205.328",
    stroke: "#F1BF0E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M533.093 183.646C533.093 183.646 533.972 189.626 540.636 189.626C548.82 189.626 550.44 183.646 550.44 183.646",
    stroke: "#F1BF0E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M570.276 116.793C570.271 116.737 570.349 116.889 570.377 116.944L570.499 117.172L570.706 117.639C570.845 117.949 570.95 118.27 571.057 118.59C571.252 119.236 571.413 119.887 571.475 120.583C571.261 120.303 571.11 119.993 570.966 119.684C570.819 119.375 570.709 119.054 570.602 118.732C570.506 118.406 570.413 118.081 570.357 117.744L570.275 117.238L570.255 116.979L570.246 116.849C570.24 116.826 570.258 116.689 570.276 116.793Z",
    fill: "#EF977F"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M449.052 354.078L449.945 382.275L449.029 391.144L415.412 390.967C414.562 390.963 413.878 390.27 413.883 389.422C413.885 388.786 414.281 388.218 414.875 387.992L429.871 381.097L427.607 351.757",
    fill: "#FFCBBD"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M412.361 390.592C412.716 389.478 413.369 388.227 414.026 387.944L429.928 381.096C438.692 384.649 450.037 381.933 450.037 381.933L450.906 393.905C450.904 394.301 450.581 394.621 450.184 394.619L412.627 394.421C411.849 394.416 412.35 390.627 412.361 390.592Z",
    fill: "#4A5FF7"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M426.485 381.781C427.376 382.943 428.13 384.209 428.727 385.545",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M424.484 382.978C425.408 384.255 425.776 384.993 426.327 386.178",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M422.792 383.852C423.418 384.694 424.033 385.858 424.52 386.788",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M450.702 392.034L412.197 391.831",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M450.355 386.306C450.355 386.306 441.438 386.369 440.637 391.982",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M417.285 386.54C417.285 386.54 419.853 390.191 420.36 391.874",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M445.153 243.281C445.153 243.281 449.244 250.169 450.426 255.308C452.302 263.471 450.422 271.835 450.422 271.835L450.339 370.407H425.383C425.383 370.407 419.845 256.81 422.306 242.123",
    fill: "#3C52EF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M429.189 370.406C429.189 370.406 423.652 256.809 426.112 242.123",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M421.488 342.975L432.827 368.808L435.282 377.379L404.021 389.744C403.232 390.056 402.339 389.67 402.027 388.88C401.793 388.289 401.947 387.614 402.415 387.183L413.761 375.195L400.724 348.814",
    fill: "#FFCBBD"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M401.051 390.534C400.965 389.368 401.105 387.965 401.609 387.456L413.812 375.174C423.269 375.205 432.785 368.456 432.785 368.456L438.054 379.241C438.2 379.61 438.019 380.027 437.65 380.172L402.725 393.988C402.001 394.273 401.053 390.57 401.051 390.534Z",
    fill: "#4A5FF7"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M410.874 377.094C412.133 377.839 413.305 378.734 414.357 379.751",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M409.462 378.95C410.795 379.792 411.411 380.339 412.364 381.233",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M408.216 380.392C409.112 380.94 410.117 381.791 410.914 382.473",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M437.166 377.582L401.36 391.745",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M434.708 372.396C434.708 372.396 426.457 375.777 427.806 381.285",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M404.11 384.939C404.11 384.939 407.854 387.369 408.952 388.742",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M402.123 259.345C389.299 290.862 389.07 294.2 386.957 309.58C384.79 325.362 408.505 371.829 408.505 371.829L431.258 361.782C431.258 361.782 416.165 319.265 417.141 311.954C418.938 298.505 434.462 275.555 434.462 275.555C434.462 275.555 441.833 269.719 443.435 261.969C445.037 254.218 441.512 246.1 441.512 246.1",
    fill: "#4A5FF7"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M425.516 263.062C425.85 262.95 435.732 259.841 435.732 259.841",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M447.304 256.954L450.554 255.921",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M409.739 258.393C409.739 258.393 393.884 292.847 391.717 308.628C389.55 324.41 412.615 369.585 412.615 369.585",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M422.421 296.806C427.346 285.974 434.464 275.555 434.464 275.555C434.464 275.555 441.834 269.719 443.436 261.969",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M399.965 181.35L406.489 192.704C406.489 192.704 402.578 201.163 392.008 197.149L389.3 191.15L399.965 181.35Z",
    fill: "#FFCBBD"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M382.631 173.668C382.631 173.668 379.42 188.77 385.011 191.463C387.918 192.862 396.048 191.997 397.967 188.897C399.391 186.597 398.832 175.707 397.088 174.387C390.426 169.337 382.631 173.668 382.631 173.668Z",
    fill: "#FFCBBD"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M396.789 169.195C394.345 164.926 389.368 165.778 381.279 170.381C380.197 170.997 377.838 171.219 377.811 172.464C377.776 174.102 378.955 176.798 380.849 177.34C382.113 177.701 382.782 177.584 384.063 177.286C385.747 176.895 387.995 177.575 387.971 179.552C387.964 180.07 387.813 181.018 388.296 181.204C388.541 181.298 389.172 181.224 389.435 181.232C390.193 181.258 390.604 182.188 390.511 182.941C390.418 183.694 390.895 184.242 390.798 184.994C390.569 186.775 392.845 188.728 394.636 188.866C396.22 188.988 400.84 188.219 403.032 185.241C404.933 182.658 404.691 178.3 401.519 171.812C400.302 169.325 397.635 168.569 396.789 169.195Z",
    fill: "#212237"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M387.823 181.881C388.339 179.462 389.587 179.191 390.665 179.848C392.102 180.724 391.785 184.174 391.252 184.999C390.173 186.671 388.884 187.186 388.153 186",
    fill: "#FFCBBD"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M389.813 192.092C391.479 190.707 391.229 188.068 391.229 188.068",
    stroke: "#E88872",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M404.982 190.08C404.982 190.08 410.667 188.622 418.711 190.967C425.495 192.944 434.137 198.027 440.636 204.939C451.892 216.909 446.701 246.653 446.701 246.653L432.067 246.099C432.067 246.099 434.364 226.986 426.699 219.322C419.034 211.657 408.218 209.859 408.218 209.859",
    fill: "#ADBBF9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M342.891 231.865C338.305 233.138 324.415 234.647 324.191 235.595C323.967 236.544 328.86 236.077 328.531 236.822C328.202 237.566 320.722 238.793 320.751 239.8C320.791 241.166 328.384 239.498 328.384 239.498C328.384 239.498 325.229 240.062 325.606 241.236C325.873 242.068 327.159 242.323 329.656 242.084C328.287 242.394 327.75 243.052 328.046 243.911C328.339 244.761 329.665 244.706 331.07 244.518C330.104 244.736 329.358 245.377 329.982 245.939C330.798 246.673 336.469 246.359 346.512 244.652",
    fill: "#FFCBBD"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M390.529 193.881C390.529 193.881 394.444 195.564 398.777 193.881C403.11 192.196 404.982 190.08 404.982 190.08C404.982 190.08 414.819 189.405 426.792 201.378C438.884 213.47 448.283 247.765 448.283 247.765L398.72 264.424C398.72 264.424 390.242 234.396 386.907 220.723C383.573 207.05 390.529 193.881 390.529 193.881Z",
    fill: "#ADBBF9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M426.144 198.231C436.05 209.8 448.284 247.765 448.284 247.765",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M390.528 193.881C383.999 196.381 378.395 202.717 374.951 209.243C369.312 219.934 365.879 227.69 365.879 227.69L337.459 231.949L338.869 247.108C338.869 247.108 358.161 246.536 373.538 244.224C384.463 242.582 392.922 219.935 392.922 219.935",
    fill: "#ADBBF9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M388.615 194.739C388.615 194.739 391.76 198.936 399.297 196.109C406.834 193.283 407.106 189.79 407.106 189.79",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M389.3 227.726L392.389 221.199",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M341.905 231.283L342.973 246.894",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M397.809 261.184L447.305 244.823",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M202.873 219.695C203.096 219.843 203.321 219.986 203.548 220.128C205.77 221.535 208.028 222.957 210.55 223.7C212.012 224.132 213.602 224.355 214.794 225.305C215.276 225.69 215.69 226.097 216.226 226.407C216.367 226.489 217.773 227.012 217.712 226.865C217.917 227.367 218.47 227.616 218.974 227.817C219.033 227.841 219.096 227.864 219.159 227.852C219.222 227.84 219.278 227.776 219.257 227.716C219.439 228.07 220.078 228.226 220.281 228.035C220.484 227.843 219.977 226.949 219.977 226.949C219.977 226.949 220.32 226.972 220.42 226.858C220.584 226.673 220.619 226.412 220.635 226.167C220.79 223.872 219.889 221.527 218.229 219.901",
    fill: "#FFCBBD"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M218.697 224.437C218.693 224.83 218.926 225.228 219.075 225.584C219.24 225.978 219.407 226.351 219.612 226.724C219.706 226.893 219.945 226.773 219.911 226.598C219.823 226.147 219.673 225.739 219.472 225.325C219.306 224.985 219.139 224.586 218.816 224.371C218.764 224.336 218.697 224.381 218.697 224.437Z",
    fill: "#F49C8E"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M216.31 224.519C217.157 225.445 218.006 226.314 218.746 227.331C218.825 227.441 219.02 227.381 218.977 227.234C218.613 225.984 217.367 225.221 216.472 224.356C216.365 224.253 216.21 224.41 216.31 224.519Z",
    fill: "#F49C8E"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M200.968 394.62L184.054 221.972",
    stroke: "#4A5FF7",
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M266.825 394.62L249.911 221.972H184.054",
    stroke: "#4A5FF7",
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M232.995 394.62L249.91 221.972",
    stroke: "#4A5FF7",
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M167.14 394.62L184.054 221.972H249.911",
    stroke: "#4A5FF7",
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M264.117 370.161H169.535",
    stroke: "#4A5FF7",
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M261.919 349.02H171.608",
    stroke: "#4A5FF7",
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M260.23 327.298H173.735",
    stroke: "#4A5FF7",
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M258.12 306.594H175.764",
    stroke: "#4A5FF7",
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M256.082 284.966H177.793",
    stroke: "#4A5FF7",
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M253.983 263.533H179.912",
    stroke: "#4A5FF7",
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M251.52 243.291H181.966",
    stroke: "#4A5FF7",
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M199.198 221.536C205.956 221.558 212.712 221.542 219.468 221.49C218.835 220.347 218.431 219.629 217.707 218.914C216.814 218.029 216.131 217.509 215.19 217.026C212.048 215.415 208.527 214.547 204.995 214.514",
    fill: "#FFCBBD"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M175.609 174.955C175.609 174.955 184.851 199.046 187.16 201.065C189.47 203.084 211.485 214.03 211.485 214.03L204.737 228.309C204.737 228.309 178.252 217.73 174.457 214.03C170.662 210.331 158.589 195.993 157.375 181.603",
    fill: "#F1BF0E"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M157.964 332.422L157.015 358.349L157.817 366.51L188.735 366.498C189.515 366.498 190.148 365.864 190.147 365.084C190.147 364.499 189.787 363.975 189.241 363.764L175.481 357.354L177.696 330.382",
    fill: "#FFCBBD"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M191.541 366.167C191.219 365.141 190.625 363.988 190.021 363.724L175.429 357.354C167.352 360.582 156.931 358.033 156.931 358.033L156.077 369.039C156.077 369.403 156.373 369.699 156.737 369.699L191.278 369.686C191.995 369.686 191.551 366.199 191.541 366.167Z",
    fill: "#FFC90D"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M178.59 358.001C177.766 359.064 177.067 360.226 176.512 361.453",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M180.428 359.111C179.573 360.282 179.231 360.959 178.719 362.046",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M181.979 359.922C181.399 360.694 180.828 361.762 180.377 362.615",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M156.273 367.32L191.685 367.308",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M156.619 362.053C156.619 362.053 164.819 362.152 165.531 367.317",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M187.03 362.419C187.03 362.419 184.651 365.764 184.178 367.31",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M151.134 234.954C151.134 234.954 148.153 248.167 154.563 264.176C154.563 264.176 157.666 280.911 157.917 300.044C158.172 319.562 155.574 344.431 155.574 353.718H181.008C181.008 353.718 184.126 327.271 184.403 300.615C184.714 270.757 182.187 237.056 182.187 228.356",
    fill: "#ADBBF9"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 353.718C177.2 353.718 180.324 326.783 180.605 299.792C180.912 270.141 178.38 236.976 178.38 228.355",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M200.963 311.32L200.014 337.248L200.816 345.408L231.734 345.396C232.514 345.396 233.147 344.763 233.146 343.982C233.146 343.396 232.786 342.872 232.24 342.662L218.48 336.252L220.695 309.28",
    fill: "#FFCBBD"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M234.541 345.066C234.22 344.04 233.625 342.887 233.022 342.623L218.43 336.253C210.354 339.481 199.932 336.932 199.932 336.932L199.078 347.938C199.078 348.303 199.374 348.598 199.739 348.598L234.28 348.585C234.995 348.585 234.552 345.098 234.541 345.066Z",
    fill: "#FFC90D"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M221.591 336.899C220.767 337.964 220.068 339.124 219.513 340.351",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M223.427 338.01C222.572 339.18 222.23 339.857 221.717 340.945",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M224.98 338.821C224.4 339.593 223.829 340.661 223.378 341.514",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M199.274 346.22L234.686 346.207",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M199.62 340.952C199.62 340.952 207.82 341.05 208.531 346.216",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M230.03 341.318C230.03 341.318 227.651 344.663 227.178 346.209",
    stroke: "#B22B19",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M193.981 236.397C193.981 236.397 218.422 259.564 223.928 274.65C227.768 285.169 222.188 333.17 222.188 333.17H197.845C197.845 333.17 200.812 289.475 199.276 284.966C197.47 279.662 176.512 261.581 176.512 261.581C176.512 261.581 167.573 259.578 163.353 250.072C159.55 241.504 161.31 231.108 161.31 231.108",
    fill: "#ADBBF9"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M188.269 236.397C188.269 236.397 213.604 263.177 218.216 274.65C221.719 283.364 216.476 333.17 216.476 333.17",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M183.883 268.174C181.963 266.431 178.639 263.44 177.626 262.552C176.976 261.982 176.232 261.533 175.414 261.25C172.897 260.377 166.668 257.54 163.352 250.072",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M170.089 244.735C170.089 244.735 177.378 244.989 180.425 244.735",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M150.441 244.735H156.318",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M237.661 177.735C240.216 176.57 251.848 171.484 252.122 172.19C252.384 172.87 248.709 175.321 249.116 175.437C249.341 175.501 252.632 174.648 254.277 173.842C255.745 173.122 258.219 172.206 258.614 172.804C259.367 173.942 251.266 177.788 251.266 177.788C251.266 177.788 252.699 177.129 253.427 178.015C254.477 179.293 252.255 180.476 252.255 180.476C252.255 180.476 253.528 179.829 253.949 180.93C254.386 182.074 252.479 183.004 252.479 183.004C252.479 183.004 253.991 182.278 254.183 183.659C254.434 185.472 242.344 189.737 242.344 189.737",
    fill: "#FFCBBD"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M178.719 165.97C178.719 165.97 176.291 167.899 172.407 167.238C168.524 166.576 167.582 164.703 167.582 164.703C167.582 164.703 157.255 166.14 152.291 197.987C148.802 220.364 149.962 238.561 149.962 238.561H197.042C197.042 238.561 198.479 189.906 196.085 180.863",
    fill: "#FFC90D"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M182.424 189.375C182.424 189.375 196.371 204.782 209.383 204.782C222.395 204.782 246.889 190.972 246.889 190.972L241.037 174.911L212.577 185.12C212.577 185.12 197.587 171.116 190.672 168.535C183.757 165.953 178.719 165.971 178.719 165.971",
    fill: "#FFC90D"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M197.418 201.237C197.418 201.237 188.657 194.557 184.43 191.418",
    stroke: "#F1BF0E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M238.321 175.885L243.68 192.7",
    stroke: "#F1BF0E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M149.818 234.643H197.143",
    stroke: "#F1BF0E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M189.108 194.93C189.569 208.463 189.108 238.561 189.108 238.561",
    stroke: "#F1BF0E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M167.75 157.763L166.681 166.355C166.681 166.355 174.975 170.704 180.476 166.081V161.07L167.75 157.763Z",
    fill: "#FFCBBD"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M179.008 144.279C179.008 144.279 188.702 156.499 185.157 161.026C183.315 163.38 177.305 162.816 174.441 161.026C172.315 159.698 166.38 152.609 167.288 150.796C170.756 143.872 179.008 144.279 179.008 144.279Z",
    fill: "#FFCBBD"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M177.762 146.517C177.921 151.469 177.288 155.897 177.288 155.897L176.546 171.98C176.546 171.98 163.754 173.344 155.573 167.663C155.573 167.663 158.316 150.764 164.414 145.643C170.213 140.773 177.763 141.125 181.597 144.275C181.597 144.275 181.064 145.751 180.348 146.091C179.632 146.429 177.762 146.517 177.762 146.517Z",
    fill: "#4A1A1A"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M178.6 154.275C177.417 152.775 176.458 153.013 175.935 153.838C175.238 154.936 176.637 157.22 177.288 157.61C178.608 158.401 179.677 158.317 179.779 157.245",
    fill: "#FFCBBD"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M180.585 162.532C179.19 162.532 178.741 161.361 178.741 161.361",
    stroke: "#E88872",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M170.561 142.761C171.416 142.543 172.013 141.65 171.989 140.768C171.966 139.886 171.385 139.069 170.606 138.654C169.827 138.239 168.881 138.2 168.031 138.436C167.706 138.526 167.389 138.656 167.119 138.857C166.015 139.674 166.044 141.439 166.826 142.567C167.146 143.028 167.591 143.433 168.138 143.562C168.684 143.69 169.818 143.495 170.459 143.115",
    fill: "#4A1A1A"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M182.588 150.336C182.831 150.469 185.383 151.574 185.4 152.603C185.41 153.184 183.994 153.815 183.994 153.815",
    fill: "#FFCBBD"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M216.149 219.518C217.672 221.16 218.18 222.779 218.796 224.094C218.824 224.153 218.852 224.215 218.854 224.28C218.863 224.583 218.408 224.61 218.125 224.503C217.477 224.258 216.874 223.898 216.349 223.446C216.141 223.267 215.944 223.071 215.705 222.935C215.27 222.686 214.749 222.657 214.252 222.595C212.206 222.343 210.145 221.325 209.152 219.518",
    fill: "#FFCBBD"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M216.149 219.518C217.196 220.484 217.948 221.749 218.529 223.04L218.978 223.997C219.008 224.116 219.082 224.213 219.053 224.38C219.023 224.556 218.866 224.682 218.749 224.719C218.505 224.804 218.299 224.779 218.084 224.716C217.38 224.464 216.745 224.091 216.181 223.614C215.905 223.369 215.681 223.145 215.393 223.037C215.102 222.918 214.765 222.875 214.415 222.831C213.701 222.745 212.982 222.585 212.314 222.309C210.979 221.773 209.755 220.82 209.152 219.517C209.927 220.714 211.142 221.518 212.442 221.967C213.101 222.177 213.771 222.34 214.464 222.401C214.815 222.438 215.189 222.472 215.56 222.613C215.944 222.751 216.24 223.038 216.492 223.255C216.998 223.703 217.597 224.068 218.221 224.306C218.341 224.349 218.508 224.358 218.598 224.324C218.646 224.305 218.644 224.296 218.644 224.296C218.652 224.286 218.611 224.219 218.605 224.169C218.453 223.843 218.325 223.512 218.194 223.184C217.685 221.874 217.05 220.62 216.149 219.518Z",
    fill: "#E88872"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9955 355.553L53.1339 382.725L54.0174 391.271L86.4122 391.099C87.23 391.096 87.8897 390.428 87.8859 389.611C87.883 388.997 87.5022 388.45 86.9291 388.233L72.4777 381.588L74.6597 353.315",
    fill: "#FFCBBD"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3517 390.739C89.0089 389.666 88.3806 388.461 87.7466 388.187L72.4241 381.588C63.9779 385.012 53.046 382.395 53.046 382.395L52.2083 393.932C52.2102 394.314 52.5215 394.621 52.9032 394.619L89.0956 394.429C89.8458 394.424 89.3631 390.772 89.3517 390.739Z",
    fill: "#4A5FF7"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7414 382.249C74.8827 383.367 74.1563 384.588 73.5813 385.876",
    stroke: "#5565AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6691 383.402C76.7799 384.634 76.4248 385.344 75.8936 386.486",
    stroke: "#5565AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3 384.243C78.6964 385.055 78.1033 386.178 77.6349 387.074",
    stroke: "#5565AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4054 392.128L89.5098 391.932",
    stroke: "#5565AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7404 386.608C52.7404 386.608 61.3322 386.668 62.1043 392.077",
    stroke: "#5565AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6073 386.835C84.6073 386.835 82.1321 390.352 81.6437 391.975",
    stroke: "#5565AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M56.996 258.314C56.996 258.314 74.213 290.578 79.6756 310.87C85.1392 331.162 77.8725 376.861 77.8725 376.861H51.0831C51.0831 376.861 56.4267 327.259 50.1007 310.87C43.7755 294.481 21.1426 251.35 21.1426 251.35",
    fill: "#ADBBF9"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7515 376.86C54.7515 376.86 59.1431 325.261 56.4709 312.514C53.7995 299.768 35.2773 270.1 35.2773 270.1",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3045 340.44L7.47079 362.262L3.1582 369.693L29.4564 388.611C30.1209 389.089 31.0462 388.938 31.5241 388.274C31.8821 387.776 31.8964 387.11 31.5613 386.598L23.7843 372.723L41.3336 349.835",
    fill: "#FFCBBD"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0441 390.049C32.3982 388.98 32.5991 387.634 32.2478 387.041L23.7388 372.691C14.8947 370.492 7.59374 361.945 7.59374 361.945L0.13002 370.781C-0.0927491 371.091 -0.0223004 371.523 0.288053 371.746L29.6679 392.882C30.2762 393.32 32.0336 390.083 32.0441 390.049Z",
    fill: "#4A5FF7"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0317 375.176C24.6789 375.576 23.3737 376.136 22.1514 376.838",
    stroke: "#5565AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9142 377.244C25.47 377.716 24.7646 378.083 23.6631 378.694",
    stroke: "#5565AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7368 378.883C26.7714 379.184 25.6319 379.744 24.7256 380.192",
    stroke: "#5565AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34863 369.439L31.4691 391.107",
    stroke: "#5565AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86731 365.172C4.86731 365.172 11.7798 370.275 9.22273 375.103",
    stroke: "#5565AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5036 384.101C30.5036 384.101 26.4328 385.49 25.0838 386.514",
    stroke: "#5565AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0781 251.349C8.9773 265.806 14.0781 277.185 14.0781 277.185C14.0781 277.185 31.4684 308.97 31.4684 315.428C31.4684 321.354 9.15723 355.111 9.15723 355.111L29.5596 371.509C29.5596 371.509 61.607 337.021 60.9996 313.152C60.2485 283.64 44.19 251.348 44.19 251.348",
    fill: "#ADBBF9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8857 252.301C12.7849 266.758 18.9434 276.502 18.9434 276.502C18.9434 276.502 35.276 309.922 35.276 316.381C35.276 322.306 12.0938 357.472 12.0938 357.472",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M52.886 339.32C57.6622 330.548 61.2056 321.24 61 313.153C60.2488 283.641 44.1904 251.349 44.1904 251.349",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M16.215 263.64C16.215 263.64 25.319 264.176 28.8891 256.857",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1045 267.817C51.1045 267.817 53.5987 268.093 53.3598 266.858C53.1208 265.624 51.1045 258.974 51.1045 258.974",
    stroke: "#525BCE",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6721 174.649C63.606 180.479 62.8692 185.63 57.8921 186.403C52.915 187.177 46.0044 185.759 44.6488 177.449C43.6987 171.622 46.9916 166.267 51.9687 165.493C56.9458 164.721 61.7382 168.819 62.6721 174.649Z",
    fill: "#FFCBBB"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2582 192.786C55.2582 192.786 51.3797 193.451 47.7402 192.457C43.4419 191.283 42.2195 189.537 42.2195 189.537L48.18 177.099L57.3764 181.269L55.2582 192.786Z",
    fill: "#FFCBBB"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4044 186.553C56.4044 186.553 52.3936 186.683 50.3173 184.715",
    stroke: "#EF977F",
    strokeMiterlimit: 10
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.621 174.471C61.621 174.471 64.1086 178.123 63.982 178.775C63.8554 179.428 62.0523 179.712 62.0523 179.712",
    fill: "#FFCBBB"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2263 182.712C47.6856 182.947 47.0335 183.041 46.5146 183.1C45.3456 183.234 44.1337 183.055 43.0855 182.507C41.171 181.508 39.9401 179.228 40.3732 177.111C40.4437 176.765 40.5551 176.427 40.6112 176.078C40.8711 174.45 39.9163 172.895 39.6488 171.269C39.3889 169.691 39.8039 168.032 40.6931 166.703C41.5823 165.374 42.9237 164.373 44.4174 163.802C45.6093 163.346 46.9164 163.182 47.9055 162.325C48.3653 161.926 48.7851 161.475 49.3002 161.15C51.7763 159.592 55.3064 160.445 57.5179 162.089C57.7806 162.284 58.0424 162.499 58.3576 162.584C58.9011 162.729 59.4685 162.503 60.0207 162.613C62.1427 163.041 63.0747 166.176 63.0528 168.051C63.0462 168.606 62.91 169.172 62.5778 169.617C62.1008 170.254 61.2888 170.556 60.4986 170.653C59.3952 170.788 58.249 170.563 57.1704 170.894C56.4126 171.126 55.7595 171.614 55.0236 171.909C53.8879 172.364 52.5627 172.321 51.4584 171.794C51.6792 172.57 51.842 173.383 51.7221 174.18C51.4965 175.679 50.2303 176.414 48.8813 176.787C49.3249 178.297 49.6876 180.195 49.2155 181.734C49.0698 182.206 48.689 182.511 48.2263 182.712Z",
    fill: "#14122D"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0656 175.563C50.0656 175.563 48.8766 174.113 47.479 175.278C45.6721 176.784 48.0255 180.026 49.4563 180.558C50.8882 181.089 51.3089 179.503 51.3089 179.503",
    fill: "#FFCBBB"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M117.705 239.034C119.587 237.447 121.319 235.624 122.845 233.558C124.371 231.492 125.603 229.3 126.567 227.034L120.543 223.815C121.385 221.693 121.919 219.494 122.161 217.277L128.998 217.249C129.424 212.231 128.662 207.168 126.779 202.496L120.236 204.481C119.352 202.435 118.196 200.49 116.767 198.709L121.576 193.861C119.989 191.98 118.167 190.247 116.1 188.721C114.034 187.195 111.842 185.963 109.576 185L106.357 191.022C104.235 190.18 102.035 189.646 99.8191 189.404L99.7906 182.567C94.7726 182.142 89.7098 182.903 85.0383 184.786L87.0232 191.329C84.9764 192.213 83.0315 193.371 81.2512 194.799L76.4027 189.989C74.5215 191.576 72.7889 193.398 71.2628 195.465C69.7367 197.532 68.5039 199.723 67.5414 201.989L73.5638 205.209C72.7222 207.331 72.1882 209.53 71.9463 211.746L65.109 211.775C64.6835 216.793 65.4451 221.855 67.3282 226.527L73.8713 224.542C74.7548 226.589 75.9114 228.534 77.3404 230.314L72.5309 235.162C74.1179 237.044 75.941 238.776 78.0068 240.302C80.0736 241.828 82.2651 243.061 84.5309 244.024L87.7506 238C89.8726 238.842 92.0717 239.376 94.288 239.618L94.3165 246.455C99.3346 246.881 104.397 246.119 109.069 244.236L107.084 237.693C109.131 236.809 111.076 235.653 112.856 234.224L117.705 239.034ZM89.8735 224.236C84.5033 220.27 83.3647 212.702 87.3307 207.331C91.2968 201.96 98.8652 200.822 104.236 204.788C109.607 208.754 110.745 216.322 106.779 221.694C102.813 227.064 95.2438 228.202 89.8735 224.236Z",
    fill: "#ADBBF9"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8684 237.56C101.666 237.8 114.297 239.082 114.189 239.831C114.084 240.552 109.814 240.792 109.975 241.183C110.207 241.738 113.426 242.222 115.255 242.327C116.887 242.421 119.492 242.838 119.543 243.553C119.64 244.914 110.694 244.286 110.694 244.286C110.724 244.697 120.441 243.162 120.64 244.292C120.927 245.921 110.567 246.722 110.234 247.113C110.234 247.113 119.024 243.923 119.237 245.129C119.449 246.334 111.671 249.377 109.189 249.424C111.218 249.002 117.195 245.637 117.35 246.517C117.504 247.395 112.22 249.692 111.359 249.834C104.287 251.004 97.052 250.312 97.052 250.312",
    fill: "#FFCBBD"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4117 191.989C55.4117 191.989 52.6966 193.275 48.5897 191.491C44.1286 189.553 43.187 187.322 43.187 187.322C43.187 187.322 18.9699 189.466 10.1106 256.66L59.6996 262.81C59.6996 262.81 63.6913 238.793 63.0535 219.356C62.646 206.981 57.8384 197.352 55.4117 191.989Z",
    fill: "#4A5FF7"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8633 218.888C40.8633 218.888 48.4888 244.439 69.0902 249.966C87.443 254.89 101.754 254.868 101.754 254.868L103.75 237.642C103.75 237.642 81.3187 233.617 72.089 227.511C65.0613 222.863 63.6904 207.971 61.9121 202.703C59.4417 195.388 55.4118 191.988 55.4118 191.988",
    fill: "#4A5FF7"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2084 187.843C41.2084 187.843 42.7278 192.53 49.7964 194.065C54.9591 195.185 56.9802 193.647 56.9802 193.647",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9993 247.07C60.9993 247.07 42.2172 238.394 41.2072 213.82",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5823 236.807L97.0547 254.671",
    stroke: "#4A5FF7",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_379_3931",
    x1: 164.674,
    y1: 340.859,
    x2: 443.322,
    y2: 62.2097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2704,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_379_3931",
    x1: 211.765,
    y1: 335.039,
    x2: 478.774,
    y2: 68.0297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2704,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare0);
export default __webpack_public_path__ + "static/media/healthcare0.27ecebf533fcca3658f53100031f97a0.svg";
export { ForwardRef as ReactComponent };